import gql from 'graphql-tag';
export const REPLY_FRAGMENT = gql `
  fragment CommentReply on SocialCommentResult {
    id
    isEdited
    urn
    messageArticleV1 {
      ... on ArticleParagraph {
        text
        markups {
          start
          end
          ... on ArticleMentionMarkup {
            userId
            user {
              pageName
            }
          }
        }
      }
    }
    createdAt
    actorUrn
    deletedAt
    commentInteractionTarget {
      id: urn
      commentsCount
      reactionsCount
      sharesCount
      userReactionType
      permissions {
        comments {
          canDelete
          canUpdate
          canDeleteMentions
        }
      }
    }
    user {
      ...SocialUserInfo
    }
    interactionTarget {
      ...SocialInteractionTarget
    }
  }
`;
export const SOCIAL_USER_INFO = gql `
  fragment SocialUserInfo on XingId {
    id
    gender
    pageName
    displayName
    occupations {
      subline
      headline
    }
    profileImage(size: SQUARE_192) {
      url
    }
    userFlags {
      displayFlag
    }
  }
`;
export const SOCIAL_INTERACTION_TARGET_FRAGMENT = gql `
  fragment SocialInteractionTarget on SocialInteractionTarget {
    id: urn
    commentsCount
    reactionsCount
    sharesCount
    userReactionType
  }
`;
export const COMMENT_FRAGMENT = gql `
  fragment Comment on SocialCommentResult {
    id
    isEdited
    urn
    messageArticleV1 {
      ... on ArticleParagraph {
        text
        markups {
          start
          end
          ... on ArticleMentionMarkup {
            userId
            user {
              pageName
            }
          }
        }
      }
    }
    createdAt
    actorUrn
    deletedAt
    commentInteractionTarget {
      id: urn
      commentsCount
      reactionsCount
      sharesCount
      userReactionType
      repliesCount
      permissions {
        comments {
          canDelete
          canUpdate
          canDeleteMentions
        }
      }
    }
    initiallyShownReplies {
      ...CommentReply
    }
    repliesPage {
      total
      nextCount
      previousCount
      pageInfo {
        hasNextPage
        startCursor
        hasPreviousPage
        endCursor
      }
    }
    user {
      ...SocialUserInfo
    }
    interactionTarget {
      ...SocialInteractionTarget
    }
  }
  ${REPLY_FRAGMENT}
`;
//# sourceMappingURL=comment-fragments.gql.js.map